import CalendlyContent from "../components/CalendlyContent/CalendlyContent";
export default function Calendly() {
  return <CalendlyContent />;
}
